import axios from "axios";
import { BASE_URL, APPLY_CUPOM } from "../endpoints/endpoints";


export async function ApplyCupom(data, onError, onStatus) {
    let url = BASE_URL + APPLY_CUPOM;

    if(!data) return;

    const postData = {
        codigo: data.cupom,
        nome: data.nome,
        email: data.email,
        valorCompra: data.valorCompra
    }

   const dataData = { ...postData }

    await axios.post(url, dataData).then((response) => {
        if (!response) {
            onError();
            return;
        }

        const data = response.data;

        const status = data.status

        onStatus(status, data);
    }).catch((error) => {
            console.error('Error:', error);

            if (!error.response || !error.response.data) {
                onError('Cupom Invalído')
                return
            } else {
                const message = error.message;
                onError(message);
            }
    });
}
